import React, { useState, useEffect, useCallback, useRef } from 'react';
import { TabBar } from '../TabManager';
import useColumnResize from '../../hooks/useColumnResize';
import useTablePagination from '../../hooks/useTablePagination';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

const toFa=n=>n==null?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const numFmt=n=>{const v=Number(n||0);return v===0?'':v.toLocaleString('fa-IR');};
const API=(path,opts={})=>fetch(`/api/income${path}`,{headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('access')}`},...opts}).then(jsonOf, netErr);

const FInput=({label,name,value,onChange,readOnly,half,type='text'})=>(
  <div style={{display:'flex',flexDirection:'column',gap:'4px',flex:half?'0 0 48%':1}}>
    <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>{label}</label>
    <input name={name} type={type} value={value} onChange={onChange} readOnly={readOnly}
      style={{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',
        fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',textAlign:'right',
        width:'100%',boxSizing:'border-box',background:readOnly?'#f5f5f5':'#fff'}}/>
  </div>
);

const INIT_WIDTHS=[50,80,60,90,90,150,120,150,100,140,90];
const EMPTY={request_no:'',request_date:'',order_person:'',refund_pay:0,taker:'',melli_code:'',account_no:'',branch_code:0,income_inout_id:0};

export default function IncomeRefundList({user,onBack}){
  // دکمه‌های فرم FRMINCOMEREFUND؛ دیدن = دسترسی
  const vbf = useFormButtons('FRMINCOMEREFUND', ["BTNNEW","BTNEDIT","BTNSENDTOACCOUNTING","BTNDELETE","BTNOK"]);
  const [rows,setRows]=useState([]);
  const [total,setTotal]=useState(0);
  const [hasMore,setHasMore]=useState(false);
  const [loading,setLoading]=useState(false);
  const [selected,setSelected]=useState(null);
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState(EMPTY);
  const [error,setError]=useState('');
  const [toast,setToast]=useState('');
  const offsetRef=useRef(0);

  /* عرض ستون‌ها */
  const {widths,TH}=useColumnResize(INIT_WIDTHS);
  const {visibleRows,search,setSearch,totalCount,LoadMoreButton}=useTablePagination({
    allRows:rows,searchFields:['taker','order_person','melli_code'],serverTotal:total,serverHasMore:hasMore,
  });

  const fetchData=useCallback(async(reset=false)=>{
    if(reset){offsetRef.current=0;setRows([]);}
    setLoading(true);
    try{
      const off=reset?0:offsetRef.current;
      const d=await API(`/refunds/?offset=${off}`);
      if(d.ok){setRows(p=>reset?d.rows:[...p,...d.rows]);setTotal(d.total);setHasMore(d.has_more);
        offsetRef.current=(reset?0:offsetRef.current)+d.rows.length;}
    }catch(e){console.error(e);}
    setLoading(false);
  },[]);
  useEffect(()=>{fetchData(true);},[]);

  const showToast=msg=>{setToast(msg);setTimeout(()=>setToast(''),2500);};
  const handleChange=e=>{const{name,value}=e.target;setForm(p=>({...p,[name]:value}));};

  const openNew=()=>{ if (!vbf.can('BTNNEW')) return;setForm(EMPTY);setError('');setModal('new');};
  const openEdit=()=>{ if (!vbf.can('BTNEDIT')) return;
    if(!selected)return;
    if(selected.sent){alert('این استرداد به تنظیم حساب ارسال شده و قابل ویرایش نیست');return;}
    setForm({request_no:selected.request_no,request_date:selected.request_date,order_person:selected.order_person,
      refund_pay:selected.refund_pay,taker:selected.taker,melli_code:selected.melli_code,
      account_no:selected.account_no,branch_code:selected.branch_code,income_inout_id:selected.income_inout_id});
    setError('');setModal('edit');
  };
  const handleSave=async()=>{
    if(+form.refund_pay<=0){setError('مبلغ استرداد معتبر نیست');return;}
    setError('');
    const url=modal==='new'?'/refunds/create/':`/refunds/${selected.id}/update/`;
    const d=await API(url,{method:'POST',body:JSON.stringify(form)});
    if(d.ok){setModal(null);fetchData(true);showToast(modal==='new'?'✅ ثبت شد':'✅ ویرایش شد');}
    else setError(d.error||'خطا');
  };
  const handleDelete=async()=>{
    if(!selected)return;
    const d=await API(`/refunds/${selected.id}/delete/`,{method:'POST'});
    if(d.ok){setModal(null);setSelected(null);fetchData(true);showToast('✅ حذف شد');}
    else setError(d.error||'خطا');
  };
  const handleSend=async()=>{ if (!vbf.can('BTNSENDTOACCOUNTING')) return;
    if(!selected)return;
    if(!window.confirm(`آیا ${selected.sent?'لغو ارسال':'ارسال'} به تنظیم حساب را تایید میکنید؟`))return;
    const d=await API(`/refunds/${selected.id}/send/`,{method:'POST'});
    if(d.ok){fetchData(true);showToast('✅ انجام شد');}
    else alert(d.error||'خطا');
  };

  return(
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}><img src={require('../../assets/images/arjan.png')} alt="" style={{width:'34px',height:'34px',borderRadius:'7px'}}/></div>
          <div><div style={s.hTitle}>رد وجوه اضافه دریافتی</div><div style={s.hSub}>بخش درآمد — سامانه ارجان</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>
      <TabBar/>
      <main style={s.main}>
        <div style={s.toolbar}>
          <div style={s.toolBtns}>
            {vbf.can('BTNNEW') && <button onClick={openNew} style={s.btnNew}>＋ جدید</button>}
            {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{...s.btnEdit,opacity:selected?1:.4}}>✎ ویرایش</button>}
            {vbf.can('BTNDELETE') && <button onClick={()=>{if(selected){setError('');setModal('delete');}}} disabled={!selected} style={{...s.btnDel,opacity:selected?1:.4}}>✕ حذف</button>}
            {vbf.can('BTNSENDTOACCOUNTING') && <button onClick={handleSend} disabled={!selected} style={{...s.btnSend,opacity:selected?1:.4}}>
              {selected?.sent?'↩ لغو ارسال':'📤 ارسال به تنظیم حساب'}
            </button>}
          </div>
          <div style={{marginRight:'auto',display:'flex',alignItems:'flex-end',gap:'8px'}}>
            <div><div style={s.fL}>جستجو</div><input value={search} onChange={e=>setSearch(e.target.value)} placeholder="دریافت کننده / درخواست کننده..." style={{...s.fI,width:'220px'}}/></div>
          </div>
          <button onClick={()=>fetchData(true)} style={s.btnRefresh}>🔄</button>
          <div style={s.countBadge}>{toFa(visibleRows.length)} از {toFa(totalCount)}</div>
        </div>

        <div style={s.tableWrap}>
          <table style={{width:'100%',borderCollapse:'collapse',tableLayout:'fixed'}}>
            <thead style={{position:'sticky',top:0,zIndex:3}}>
              <tr>
                <TH idx={0}>ردیف</TH>
                <TH idx={1}>شماره استرداد</TH>
                <TH idx={2}>سال</TH>
                <TH idx={3}>شماره درخواست</TH>
                <TH idx={4}>تاریخ</TH>
                <TH idx={5} right>درخواست کننده</TH>
                <TH idx={6} gold>مبلغ استرداد</TH>
                <TH idx={7} right>دریافت کننده</TH>
                <TH idx={8}>کد ملی</TH>
                <TH idx={9}>حساب</TH>
                <TH idx={10}>وضعیت</TH>
              </tr>
            </thead>
            <tbody>
              {visibleRows.length===0&&!loading&&(<tr><td colSpan={11} style={s.empty}>📭 رکوردی یافت نشد</td></tr>)}
              {visibleRows.map((r,i)=>{
                const sel=selected?.id===r.id;
                const bg=sel?'#64b5f6':r.sent?'#e8f5e9':i%2===0?'#fff':'#fdf6e3';
                return(<tr key={r.id} onClick={()=>setSelected(r)} style={{cursor:'pointer',background:bg}}
                  onMouseEnter={e=>{if(!sel)e.currentTarget.style.background='#bbdefb';}}
                  onMouseLeave={e=>{if(!sel)e.currentTarget.style.background=bg;}}>
                  <td style={s.td}>{toFa(i+1)}</td>
                  <td style={s.td}>{toFa(r.refund_no)}</td>
                  <td style={s.td}>{toFa(r.refund_year)}</td>
                  <td style={s.td}>{r.request_no}</td>
                  <td style={{...s.td,direction:'ltr'}}>{toFa(r.request_date)}</td>
                  <td style={{...s.td,textAlign:'right'}}>{r.order_person}</td>
                  <td style={{...s.td,direction:'ltr',textAlign:'left',fontWeight:'700',color:'#b71c1c'}}>{numFmt(r.refund_pay)}</td>
                  <td style={{...s.td,textAlign:'right',fontWeight:'600'}}>{r.taker}</td>
                  <td style={{...s.td,direction:'ltr'}}>{r.melli_code}</td>
                  <td style={{...s.td,direction:'ltr',fontSize:'11px'}}>{r.account_no}</td>
                  <td style={s.td}>{r.sent?<span style={{color:'#1b5e20',fontWeight:'700'}}>✅ ارسال شده</span>:<span style={{color:'#888'}}>—</span>}</td>
                </tr>);
              })}
            </tbody>
          </table>
        </div>
        <LoadMoreButton onClick={()=>fetchData(false)} loading={loading}/>
      </main>

      {/* مودال جدید/ویرایش */}
      {(modal==='new'||modal==='edit')&&(
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={s.modal} onClick={e=>e.stopPropagation()}>
            <div style={s.mHeader}><div style={s.mTitle}>{modal==='new'?'➕ استرداد جدید':'✎ ویرایش استرداد'}</div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button></div>
            <div style={s.mBody}>
              {error&&<div style={s.errBox}>{error}</div>}
              <div style={s.row}>
                <FInput label="شماره درخواست" name="request_no" value={form.request_no} onChange={handleChange} half/>
                <FInput label="تاریخ درخواست" name="request_date" value={form.request_date} onChange={handleChange} half/>
              </div>
              <div style={s.row}>
                <FInput label="درخواست کننده" name="order_person" value={form.order_person} onChange={handleChange} half/>
                <FInput label="مبلغ استرداد" name="refund_pay" value={form.refund_pay} onChange={handleChange} type="number" half/>
              </div>
              <div style={s.row}>
                <FInput label="دریافت کننده" name="taker" value={form.taker} onChange={handleChange} half/>
                <FInput label="کد ملی" name="melli_code" value={form.melli_code} onChange={handleChange} half/>
              </div>
              <div style={s.row}>
                <FInput label="شماره حساب (شبا)" name="account_no" value={form.account_no} onChange={handleChange} half/>
                <FInput label="کد شعبه بانک" name="branch_code" value={form.branch_code} onChange={handleChange} type="number" half/>
              </div>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={handleSave} style={s.btnSave}>ثبت</button>}
            </div>
          </div>
        </div>
      )}

      {/* مودال حذف */}
      {modal==='delete'&&selected&&(
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={{...s.modal,maxWidth:'440px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...s.mHeader,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>
              <div style={s.mTitle}>⚠️ تأیید حذف</div><button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button></div>
            <div style={s.mBody}>
              {error&&<div style={s.errBox}>{error}</div>}
              <p style={{fontSize:'14px',lineHeight:'2'}}>آیا از حذف استرداد شماره <b>{toFa(selected.refund_no)}</b> مطمئن هستید؟</p>
              {selected.sent&&<p style={{color:'#c62828',fontWeight:'700'}}>⚠️ این استرداد به تنظیم حساب ارسال شده و قابل حذف نیست.</p>}
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>انصراف</button>
              {!selected.sent&&(vbf.can('BTNDELETE') && <button onClick={handleDelete} style={{...s.btnSave,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>حذف</button>)}
            </div>
          </div>
        </div>
      )}

      {toast&&<div style={s.toast}>{toast}</div>}
    </div>
  );
}

/* استایل‌ها */
const s={
  page:{height:'100vh',overflow:'hidden',background:'#f0f2f7',fontFamily:"'Vazirmatn',Tahoma,sans-serif",direction:'rtl',display:'flex',flexDirection:'column'},
  header:{background:'linear-gradient(135deg,#0a1628,#1a2f50)',padding:'10px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 16px rgba(0,0,0,0.3)',flexShrink:0},
  hLeft:{display:'flex',alignItems:'center',gap:'12px'},
  backBtn:{padding:'6px 14px',background:'rgba(255,255,255,0.12)',color:'#fff',border:'1px solid rgba(255,255,255,0.25)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  hLogo:{width:'40px',height:'40px',background:'rgba(200,168,75,0.12)',border:'1px solid rgba(200,168,75,0.3)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center'},
  hTitle:{fontSize:'15px',fontWeight:'700',color:'#fff'},
  hSub:{fontSize:'11px',color:'rgba(255,255,255,0.55)'},
  userName:{fontSize:'13px',color:'rgba(255,255,255,0.85)'},
  main:{padding:'8px 20px',flex:1,display:'flex',flexDirection:'column',overflow:'hidden',minHeight:0},
  toolbar:{display:'flex',alignItems:'center',gap:'8px',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',marginBottom:'6px',flexWrap:'wrap',flexShrink:0},
  toolBtns:{display:'flex',gap:'7px'},
  fL:{fontSize:'11px',fontWeight:'600',color:'#555'},
  fI:{padding:'7px 11px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',textAlign:'right'},
  btnNew:{padding:'7px 16px',background:'linear-gradient(135deg,#1b5e20,#2e7d32)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  btnEdit:{padding:'7px 16px',background:'linear-gradient(135deg,#1a237e,#283593)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnDel:{padding:'7px 16px',background:'linear-gradient(135deg,#b71c1c,#c62828)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnSend:{padding:'7px 16px',background:'linear-gradient(135deg,#e65100,#f57c00)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnRefresh:{padding:'7px 12px',background:'linear-gradient(135deg,#37474f,#455a64)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  countBadge:{padding:'4px 10px',background:'#1a2f50',color:'#C8A84B',borderRadius:'16px',fontSize:'11px',fontWeight:'700'},
  tableWrap:{overflowX:'auto',overflowY:'auto',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.1)',background:'#fff',flex:1,minHeight:0},
  td:{padding:'7px 9px',borderBottom:'1px solid #f0f0f0',textAlign:'center',fontSize:'12px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},
  empty:{textAlign:'center',padding:'48px',color:'#999',fontSize:'14px'},
  overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.55)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'},
  modal:{background:'#fff',borderRadius:'16px',width:'100%',maxWidth:'640px',maxHeight:'90vh',display:'flex',flexDirection:'column',boxShadow:'0 20px 60px rgba(0,0,0,0.4)'},
  mHeader:{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 20px',background:'linear-gradient(135deg,#0a1628,#1a2f50)',borderRadius:'16px 16px 0 0'},
  mTitle:{fontSize:'15px',fontWeight:'700',color:'#fff'},
  closeBtn:{background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',color:'#fff',width:'30px',height:'30px',borderRadius:'50%',cursor:'pointer',fontSize:'13px',display:'flex',alignItems:'center',justifyContent:'center'},
  mBody:{overflowY:'auto',flex:1,padding:'18px'},
  mFooter:{display:'flex',justifyContent:'flex-end',gap:'10px',padding:'12px 18px',borderTop:'1px solid #f0f2f7',background:'#f8f9fa',borderRadius:'0 0 16px 16px'},
  row:{display:'flex',gap:'12px',marginBottom:'12px',flexWrap:'wrap'},
  errBox:{background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'8px',padding:'10px 14px',color:'#c62828',marginBottom:'10px',fontSize:'13px'},
  btnCancel:{padding:'8px 18px',background:'#e0e0e0',color:'#333',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  btnSave:{padding:'8px 22px',background:'linear-gradient(135deg,#1b5e20,#2e7d32)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  toast:{position:'fixed',bottom:'24px',right:'24px',background:'#1b5e20',color:'#fff',padding:'12px 24px',borderRadius:'10px',fontSize:'14px',fontWeight:'600',zIndex:2000,boxShadow:'0 4px 16px rgba(0,0,0,0.25)'},
};
